import { Box, Tooltip } from '@mui/material';
import { InsertDriveFile as FileIcon } from '@mui/icons-material';
import { StyledChip } from './SharedStyles';

export const FileExtensionsDetail = ({ extensions }: { extensions?: string[] }) => {
  if (!extensions) return;

  if (extensions.length === 1) {
    return <StyledChip icon={<FileIcon />} label={extensions[0]} size='small' color='default' />;
  }

  if (extensions.length <= 3) {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {extensions.map(extension => (
          <StyledChip key={extension} icon={<FileIcon />} label={extension} size='small' color='default' />
        ))}
      </Box>
    );
  }

  return (
    <Tooltip title={extensions.join(', ')}>
      <StyledChip icon={<FileIcon />} label={`${extensions.length} types`} size='small' color='default' />
    </Tooltip>
  );
};
